const initContratoUsuario = () => {
    const aceptarContrato = document.querySelector('#aceptar-contrato');

    if (!aceptarContrato) return;

    const check = document.querySelector('input.check-input');
    
    check.addEventListener('change', () => {
        aceptarContrato.disabled = !check.checked;
    });

    const protocol = window.location.protocol;
    const hostname = window.location.hostname;

    aceptarContrato.addEventListener('click', async () => {
        const user_id = aceptarContrato.getAttribute('data-id');
        const restBase = protocol + '//' + hostname + '/wp-json/contrato-usuario-rest/v1';

        const data = {
            action: 'user_acciones_rest',
            user_id,
        };

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': user_acciones_rest.apiNonce,
            },
            credentials: 'same-origin',
            body: JSON.stringify({
                data: data,
            }),
        };

        fetch(restBase + '/update', options)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    // Mostrar mensaje de éxito
                    alert('Contrato aceptado correctamente');
                    window.location.href = '/mi-cuenta/video-introduccion/';
                } else {
                    // Mostrar mensaje de error
                    alert(data.message);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('Ocurrió un error al aceptar el contrato');
            }); 
    });
};

export default initContratoUsuario;
